<template>
  <hcc-modal
    name="user-multimedia"
    title="Multimedia"
    :width="700"
    :buttons="['exit']"
    @before-open="beforeOpen"
  >
    <tabs>
      <tab
        v-for="(tab, index) in options"
        :key="index"
        :clientId="clientId"
        :channelId="channelId"
        :icon="tab.icon"
        :name="tab.name"
        :title="tab.title"
        :selected="tab.selected"
      >
        <component :clientId="clientId" :is="tab.component"/>
      </tab>
    </tabs>
  </hcc-modal>
</template>

<script>
import { mapMutations } from 'vuex';
import listClientMultimedia from '@/graphql/queries/listMultimedia.gql';
import EventBus from '@/eventBus';
import { USER_MULTIMEDIA_LOAD, USER_MULTIMEDIA_LOAD_STATUS } from '@/eventTypes';

export default {
  components: {
    HccModal: () => import('@/components/shared/HccModal/index.vue'),
    Tabs: () => import('@/components/MultimediaTabs.vue'),
    Tab: () => import('@/components/MultimediaTab.vue'),
    MultimediaDocuments: () => import('@/components/userMultimedia/MultimediaDocuments.vue'),
    MultimediaImages: () => import('@/components/userMultimedia/MultimediaImages.vue'),
    MultimediaVideos: () => import('@/components//userMultimedia/MultimediaVideos.vue'),
  },
  data() {
    return {
      clientId: null,
      channelId: null,
    };
  },
  computed: {
    options() {
      return [
        {
          icon: 'type-image-icon',
          title: this.$t('multimedia.image'),
          name: 'image',
          selected: true,
          component: 'multimedia-images',
        },
        {
          icon: 'type-document-icon',
          title: this.$t('multimedia.document'),
          name: 'document',
          selected: false,
          component: 'multimedia-documents',
        },
        {
          icon: 'type-video-icon',
          title: this.$t('multimedia.video'),
          name: 'video',
          selected: false,
          component: 'multimedia-videos',
        },
      ];
    },
  },
  created() {
    EventBus.$on(USER_MULTIMEDIA_LOAD, ({
      clientId,
      type,
      lastId,
      channelId,
    }) => {
      if (this.clientId === clientId) {
        this.fetchMultimedia(clientId, type, lastId, channelId);
      }
    });
  },
  destroyed() {
    EventBus.$off(USER_MULTIMEDIA_LOAD);
  },
  methods: {
    ...mapMutations(['addUserMultimedia']),
    async fetchMultimedia(clientId, type, lastId, channelId) {
      const { data } = await this.$apollo.mutate({
        mutation: listClientMultimedia,
        variables: {
          clientId,
          type,
          lastId,
          length: 20,
          channelId,
        },
      });

      const notEmpty = data.listClientMultimedia.multimedia.length > 0;

      if (notEmpty) {
        this.addUserMultimedia({
          data: data.listClientMultimedia.multimedia,
          type,
          id: clientId,
          total: data.listClientMultimedia.total,
        });
      }

      EventBus.$emit(USER_MULTIMEDIA_LOAD_STATUS, { type, notEmpty });
    },
    beforeOpen({ params }) {
      this.clientId = params.clientId;
      this.channelId = params.channelId;
    },
  },

};
</script>
